import { type FiltersMap } from "utils/filterUtils";
import {
  MultiSelectWithWindow,
  type MultiSelectWithWindowItem,
  type MultiSelectWithWindowProps,
} from "./MultiSelectWithWindow";
import { clone } from "lodash";

export type Props<T extends MultiSelectWithWindowItem> = {
  filter: FiltersMap;
  propertyName: string;
  updateFilter: Function;
} & Omit<MultiSelectWithWindowProps<T>, "filter">;

export const FilterMultiSelectWithWindow = <T extends MultiSelectWithWindowItem>({
  filter,
  propertyName,
  updateFilter,
  ...multiSelectWindowProps
}: Props<T>) => {
  function handleChange(newItems: MultiSelectWithWindowItem[]) {
    const newFilter = clone(filter);

    if (newItems.length === 0) {
      delete newFilter[propertyName];
    } else {
      newFilter[propertyName] = newItems;
    }
    updateFilter(newFilter);
  }

  return (
    <MultiSelectWithWindow
      {...multiSelectWindowProps}
      filter={filter[propertyName] as FiltersMap[]}
      onCheckedItemsChanged={handleChange}
    />
  );
};
